import React, { Component } from 'react'
import { MetaData } from '../apis/meta.api'
import InputText from '../components/InputText'

interface InventoryCreateMetadataFieldProps {
  meta: MetaData
  onChange: (metaId: number, value: string) => void
}

interface InventoryCreateMetadataFieldState {
  value: string
}

export default class InventoryCreateMetadataField
  extends Component<
    InventoryCreateMetadataFieldProps,
    InventoryCreateMetadataFieldState
  > {
  constructor (props: InventoryCreateMetadataFieldProps) {
    super(props)
    this.state = {
      value: ''
    }
    this.handleInputChange = this.handleInputChange.bind(this)
  }

  handleInputChange (name: string, value: string) {
    if (name === this.props.meta.value) {
      this.setState({ value })
      this.props.onChange(this.props.meta.id, value)
    }
  }

  render () {
    const { meta } = this.props
    return meta.value && (
      <InputText
        name={meta.value}
        value={this.state.value}
        label={meta.value}
        onChange={this.handleInputChange} />
    )
  }
}
